import React, {useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {RootState} from "../../../reducers";
import {useSessionService} from "../../services/Session/sessionService";
import {getSession} from "../../services/Session/reducer";
import AppConfig from "../../services/AppConfig";
import {usePrefix} from "../../services/Prefix";
import {getStoreConfig} from "../../services/Store/reducer";
import {DineInType} from "../../services/Api/types";
import LoadingContainer from "../../components/Common/LoadingContainer";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function DineInOrderTypePage(props: Props) {
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const sessionService = useSessionService();
    const prefix = usePrefix();

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            let dineInType = props.config?.ordering?.dine_in_table ? DineInType.TABLE : props.config?.ordering?.dine_in_counter ? DineInType.COUNTER : undefined;
            let tableNumber: string | undefined = undefined;

            if (location.search) {
                const searchParams = new URLSearchParams(location.search);
                const tableNumberParam = searchParams.get('table');
                const numberParam = searchParams.get('number');

                if (tableNumberParam) {
                    tableNumber = tableNumberParam;
                } else if (numberParam) {
                    tableNumber = numberParam;
                }

                if (tableNumber && props.config?.ordering?.dine_in_table) {
                    dineInType = DineInType.TABLE
                }
            }

            await sessionService.update({
                ...props.session,
                order_type: "DINE_IN",
                table_number: tableNumber,
                dine_in_type: dineInType
            });
            setLoading(false);
        } catch (error) {
            return null;
        }
    }

    return (
        loading ? <LoadingContainer/> : <Navigate to={AppConfig.getLinkWithPrefix("/", prefix)}/>
    );
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);

export default connector(DineInOrderTypePage);
